import { useQuery, UseQueryOptions } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { ActionLink, fetchActionLink } from "./api"

export function useActionLink(id: string, options?: Omit<UseQueryOptions<ActionLink, Error>, "queryKey" | "queryFn">) {
  const getContext = useApiContext()

  return useQuery<ActionLink, Error>({
    queryKey: ["action-link", id],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")

      const data = await fetchActionLink(context, id)
      return data
    },
    enabled: !!id,
    ...options,
  })
}
